(function (window) {
    "use strict";
    function defineRoleHelper() {
        let roleHelper = {};
        roleHelper.role = {
            admin: 1,
            customerUser: 2,
            salesRep: 3,
            logisticsManager: 4,
            salesManager: 5,
            depotSupervisor: 6,
            customerAdminUser: 7,
            customerShiftSupervisor: 8,
            customerBuyer: 9,
            customerDriver: 10
        };
        return roleHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (roleHelper) === "undefined") {
        window.roleHelper = defineRoleHelper();
    } else {
        console.log("roleHelper already defined.");
    }
})(window);